module.exports = __webpack_public_path__ + "static/media/logo.ce0569ed.png";